import React from 'react';

const NotFound = () => {
  return (
    <div class='col-md-6 col-md-offset-3 mar80'>
      <h1>404</h1>
    </div>
  );
};
export default NotFound;
